import React, {Component} from "react";
import PropTypes from "prop-types";

import {cloneDeep, remove} from "lodash";

import {
    Input,
    Spinner,
    Col,
    Row,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Button,
    Card,
    CardTitle,
    CardBody,
    ListGroup,
    ListGroupItem,
    Alert,
} from "reactstrap";
//classes
import WbSession from "classes/Session.jsx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCreditCard, faCheck } from '@fortawesome/pro-solid-svg-icons';

class CreditCardField extends Component {
    static contextType = WbSession;
    
    debug = false;
    state = {
        cardFName: '',
        cardLName: '',
        cardNum: '',
        expiryMth: '',
        expiryYr: '',
        cardCvn: '',
        cardToken: '',
        showErrors: false,
        encKey: '',
        serverLoading: false,
        serverError: false,
        serverErrorMsg: '',
    };
    
    constructor( props ){
        super( props );
        
        const {
            value
        } = this.props;
    }
    
    get_encryption_key = async () => {
        this.setState({serverLoading:true});
        
        const data = await this.context.getEncryptionKey();
        if( data.success && typeof data.enckey != "undefined" ){
            this.setState({
                encKey: data.enckey,
                serverLoading: false,
                serverError: false,
            });
        } else {
            const errorMsg = data.error ?? 'Failed to validate Credit Card. Unknown server error.';
            
            this.setState({
                encKey: 'error',
                serverLoading: false,
                serverError: true,
                serverErrorMsg: errorMsg,
            });
        }
    };
    
    get_token = async () => {
        const {
            onChange,
        } = this.props;
        const {
            cardFName,
            cardLName,
            cardNum,
            expiryMth,
            expiryYr,
            cardCvn,
            encKey,
        } = this.state;
        
        this.setState({serverLoading:true,showErrors:false});
        
        if( '' == encKey ){
            this.setState({serverError:true,serverErrorMsg:'Encryption key not found. Please save, reload your page and try again.'});
            return;
        }
        const encryptedCardNum = eCrypt.encryptValue(cardNum, encKey);
        const encryptedCvn = eCrypt.encryptValue(cardCvn, encKey);
        
        const data = await this.context.getCreditCardToken( cardFName, cardLName, encryptedCardNum, expiryMth, expiryYr, encryptedCvn );
        
        if( data.success && typeof data.card != "undefined" ){
            this.setState({
                serverLoading: false,
                serverError: false,
            });
            // Trigger update with new values
            const newValue = JSON.stringify( {
                name: cardFName + " " + cardLName,
                token: data.cust_id,
                card: data.card,
            } );
            onChange( newValue );
        } else {
            const errorMsg = data.error ?? 'Failed to validate Credit Card. Unknown server error.';
            
            this.setState({
                serverLoading: false,
                serverError: true,
                serverErrorMsg: errorMsg,
            });
        }
    };
    
    addGaps = (str, gapNo) => {
        const inputStr = str.trim(" ");
        let newStr = " ";
        let len = inputStr.length;
        for (let i = 0; i<len; i++) {
            newStr = newStr + inputStr[i];
            while(newStr.length % (gapNo+1) === 0) {
                newStr = newStr + " ";
            }
        }
        
        newStr = newStr.trim(" ");
        
        if( newStr.length > 19 ){ // 4*4 digits, plus 3 spaces
            newStr = newStr.substring(0, 19);
        }
        
        return newStr;
    };
    
    // Remove spaces in credit card number and trim to correct length
    trimGaps = ( str ) => {
        let newStr = str.replaceAll( " ", "" );
        if( newStr.length > 16 ){ // 4*4 digits
            newStr = newStr.substring(0, 16);
        }
        return newStr;
    };
    
    render(){
        const {
            fldId,
            value,
            placeholder,
            onChange,
            error,
            readonly,
        } = this.props;
        
        const {
            cardFName,
            cardLName,
            cardNum,
            expiryMth,
            expiryYr,
            cardCvn,
            // Errors
            showErrors,
            // Encryption Key
            encKey,
            // Server status
            serverLoading,
            serverError,
            serverErrorMsg,
        } = this.state;
        
        if( '' == encKey && !serverLoading ){
            // Get the Encryption Key
            this.get_encryption_key();
        }
        
        let fldClass = '';
        if( readonly ){
            fldClass += ' form-control-muted';
        }
        
        if( '' != value ){
            let decodedVal = {};
            try{
                decodedVal = JSON.parse(value);
            }catch(e){
                console.warn("Failed to decode JSON string (Credit Card token)",value);
            }
            
            const custName = decodedVal.name ?? 'Credit Card';
            const custToken = decodedVal.token ?? null;
            const cardValue = decodedVal.card ?? null;
            
            if( null != custToken && null != cardValue ){
                // Show existing Credit Card
                return (
                    <Card className="bg-primary p-3">
                        <CardBody>
                            <CardTitle className="mb-3 text-white" tag="h3">
                                {custName}
                            </CardTitle>
                        </CardBody>
                        <ListGroup className="bg-primary" flush>
                            <ListGroupItem>{this.addGaps(cardValue, 4)}</ListGroupItem>
                        </ListGroup>
                        <a
                            className="text-white text-right"
                            onClick={e=>{
                                e.preventDefault();
                                onChange( '' );
                            }}
                        >
                            Clear
                        </a>
                    </Card>
                );
            }
        }
        
        let monthOptions = [];
        for (let i = 1; i <= 12; i++) {
            let mStr = i;
            if( i<=9 ){
                mStr = "0"+mStr;
            }
            monthOptions.push( <option key={i} value={mStr}>{mStr}</option> );
        }
        
        const currentYear = new Date().getFullYear();
        let yearOptions = [];
        for (let i = 0; i <= 7; i++) {
            const optYear = currentYear + i;
            yearOptions.push( <option key={i} value={optYear}>{optYear}</option> );
        }
        
        const reqStar = (<span className="fld-required">*</span>);
        
        let fieldsValid = true;
        let fldClasses = {};
        if( '' == cardFName ){
            fieldsValid = false;
            if( showErrors ) fldClasses.cardFName = 'fld-error';
        } else if( '' == cardLName ){
            fieldsValid = false;
            if( showErrors ) fldClasses.cardLName = 'fld-error';
        } else if( '' == cardNum ){
            fieldsValid = false;
            if( showErrors ) fldClasses.cardNum = 'fld-error';
        } else if( '' == expiryMth ){
            fieldsValid = false;
            if( showErrors ) fldClasses.expiryMth = 'fld-error';
        } else if( '' == expiryYr ){
            fieldsValid = false;
            if( showErrors ) fldClasses.expiryYr = 'fld-error';
        } else if( '' == cardCvn ){
            fieldsValid = false;
            if( showErrors ) fldClasses.cardCvn = 'fld-error';
        }
        
        return (
            <>
            {(serverError) ? (
                <Alert color="danger">Error: {serverErrorMsg}</Alert>
            ) : (null)}
            <Row>
                <Col>
                    <span className="cc_label">Name on Card {reqStar}</span>
                    <br />
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                                <FontAwesomeIcon className="inputIcon" icon={faUser} />
                            </InputGroupText>
                        </InputGroupAddon>
                        <Input
                            id={'cardfname_'+fldId}
                            type="text"
                            value={cardFName}
                            placeholder="First"
                            onChange={(e)=>{
                                this.setState({cardFName: e.target.value});
                            }}
                            invalid={error}
                            className={fldClasses.cardFName??''}
                        />
                        <Input
                            id={'cardlname_'+fldId}
                            type="text"
                            value={cardLName}
                            placeholder="Last"
                            onChange={(e)=>{
                                this.setState({cardLName: e.target.value});
                            }}
                            invalid={error}
                            className={fldClasses.cardLName??''}
                        />
                    </InputGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <span className="cc_label">Card Number {reqStar}</span>
                    <br />
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                                <FontAwesomeIcon className="inputIcon" icon={faCreditCard} />
                            </InputGroupText>
                        </InputGroupAddon>
                        <Input
                            id={'cardnum_'+fldId}
                            type="text"
                            value={this.addGaps(cardNum, 4)}
                            placeholder={placeholder}
                            onChange={(e)=>{
                                const updatedNum = this.trimGaps( e.target.value );
                                this.setState({cardNum: updatedNum});
                            }}
                            invalid={error}
                            className={fldClasses.cardNum??''}
                        />
                    </InputGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <span className="cc_label">Expiry {reqStar}</span>
                    <br />
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                                Date
                            </InputGroupText>
                        </InputGroupAddon>
                        <Input
                            id={'cardmonth_'+fldId}
                            type="select"
                            value={expiryMth}
                            placeholder='MM'
                            onChange={(e)=>{
                                this.setState({expiryMth: e.target.value});
                            }}
                            invalid={error}
                            className={fldClasses.expiryMth??''}
                        >
                            <option key="dflt" value='' disabled>MM</option>
                            {monthOptions}
                        </Input>
                        <InputGroupAddon>
                            <InputGroupText>
                                /
                            </InputGroupText>
                        </InputGroupAddon>
                        <Input
                            id={'cardyear_'+fldId}
                            type="select"
                            value={expiryYr}
                            placeholder='YYYY'
                            onChange={(e)=>{
                                this.setState({expiryYr: e.target.value});
                            }}
                            invalid={error}
                            className={fldClasses.expiryYr??''}
                        >
                            <option key="dflt" value='' disabled>YYYY</option>
                            {yearOptions}
                        </Input>
                    </InputGroup>
                </Col>
                <Col xs={6} md={4}>
                    <span className="cc_label">CVV/CNV {reqStar}</span>
                    <br />
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                                CVN
                            </InputGroupText>
                        </InputGroupAddon>
                        <Input
                            id={'cardcvn_'+fldId}
                            type="text"
                            value={cardCvn}
                            placeholder='000'
                            onChange={(e)=>{
                                let newVal = e.target.value.replace(/\D/g,"");
                                if( newVal.length > 4 ){ // 4*4 digits, plus 3 spaces
                                    newVal = newVal.substring(0, 4);
                                }
                                this.setState({cardCvn: newVal});
                            }}
                            invalid={error}
                            className={fldClasses.cardCvn??''}
                        />
                    </InputGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    {serverLoading?(
                        <div className="text-center">
                            <Spinner color="primary" />
                        </div>
                    ):(null)}
                </Col>
                <Col className="col-auto">
                    <br />
                    <Button
                        color={fieldsValid?"primary":"secondary"}
                        size="sm"
                        type="button"
                        onClick={ e => {
                            e.preventDefault();
                            if( fieldsValid && !serverLoading ){
                                this.get_token();
                            } else {
                                this.setState({showErrors:true});
                            }
                        }}
                    >
                        Validate Card <FontAwesomeIcon className="inputIcon" icon={faCheck} />
                    </Button>
                </Col>
            </Row>
            </>
        );
    }
}

CreditCardField.propTypes = {
    fldId: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
    placeholder: PropTypes.string,
    readonly: PropTypes.bool,
    error: PropTypes.bool,
    onChange: PropTypes.func
};

CreditCardField.defaultProps = {
    fldId: null,
    value: null,
    placeholder: null,
    readonly: null,
    error: false,
    onChange: (newVal) => {console.log('Field value updated',newVal)}
}

export default CreditCardField;
